<div class="flex flex-col gap-1.5" [class]="containerClass()">
  @if (labelText()) {
    <label class="checklist-task-label label" [attr.for]="id()">
      {{ labelText() }}
    </label>
  }

  <!-- `data-presence-target` so `app-remarks`, which shows presence itself and is therefore not
       auto-discovered, still gets the ring here once its accordion is open. -->
  <div class="relative h-full">
    <textarea
      #textareaRef
      data-presence-target
      [id]="id()"
      class="remarks-textarea"
      [class]="textareaClass()"
      [attr.placeholder]="placeholder() || null"
      [attr.rows]="rows()"
      [formField]="field()">
    </textarea>
  </div>
  @if (showError()) {
    <p class="text-error-primary m-0 p-0">{{ errorMessage() }}</p>
  }
</div>
